<script setup lang="ts">
import { useAddressBookStore } from '@/store/addressBook';
import { computed } from 'vue';
const props = defineProps<{
  address: string;
}>();
const store = useAddressBookStore();
const isSaved = computed(() => store.isSaved(props.address));
const addressBookItem = computed(() => store.getItem(props.address));

const isPinned = computed(() => addressBookItem.value?.pinned);

async function onClick() {
  if (isSaved.value) {
    store.removeAddress(props.address);
  } else {
    await store.addAddress(props.address);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
}

async function pin() {
  if (!isSaved.value) {
    onClick();
  }
  store.pinAddress(props.address, !addressBookItem.value?.pinned);
}
</script>

<template>
  <div class="flex flex-row gap-2">
    <!-- <v-hover v-if="isSaved">
      <template v-slot:default="{ isHovering, props }">
        <v-btn
          v-bind="props"
          @click="pin"
          class="min-w-[100px]"
          :variant="isPinned ? 'plain' : undefined"
          :border="!!isPinned"
          :color="isPinned && isHovering ? 'error' : undefined"
        >
          <v-icon
            size="small"
            class="mr-1"
            :icon="
              isPinned || isHovering
                ? 'mdi-pin'
                : 'mdi-pin-outline'
            "
          ></v-icon>
          <span>{{
            isHovering && isPinned ? 'Unpin' : isPinned ? 'Pinned' : 'Pin'
          }}</span></v-btn
        </v-btn>
      </template>
    </v-hover> -->

    <v-hover>
      <template v-slot:default="{ isHovering, props }">
        <v-btn
          v-bind="props"
          @click="onClick"
          class="min-w-[110px]"
          :variant="isSaved ? 'plain' : undefined"
          :border="!!isSaved"
          :color="isSaved && isHovering ? 'error' : undefined"
        >
          <v-icon icon="mdi-content-save" size="small" class="mr-1"></v-icon>
          <span>{{
            isHovering && isSaved ? 'Unsave' : isSaved ? 'Saved' : 'Save'
          }}</span></v-btn
        >
      </template>
    </v-hover>
  </div>
</template>
